import { render, staticRenderFns } from "./detail_config.vue?vue&type=template&id=ef01fe90"
import script from "./detail_config.vue?vue&type=script&lang=js"
export * from "./detail_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef01fe90')) {
      api.createRecord('ef01fe90', component.options)
    } else {
      api.reload('ef01fe90', component.options)
    }
    module.hot.accept("./detail_config.vue?vue&type=template&id=ef01fe90", function () {
      api.rerender('ef01fe90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/customform/detail_config.vue"
export default component.exports